import { render, staticRenderFns } from "./explain-query-metrics.component.vue?vue&type=template&id=29467446&scoped=true"
import script from "./explain-query-metrics.component.vue?vue&type=script&lang=ts"
export * from "./explain-query-metrics.component.vue?vue&type=script&lang=ts"
import style0 from "./explain-query-metrics.component.vue?vue&type=style&index=0&id=29467446&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29467446",
  null
  
)

export default component.exports